import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Image, Message, SocialMedia } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { DomainService } from 'src/app/shared/services/domain.service';
import { SettingsService } from 'src/app/shared/services/settings.service';

@Component({
  selector: 'app-social-media-crud',
  templateUrl: './social-media-crud.component.html',
  styleUrls: ['./social-media-crud.component.scss']
})
export class SocialMediaCrudComponent implements OnInit {
  @Input() socialMedia: SocialMedia;
  @Input() context: Context;
  @Input() socialMedias: SocialMedia[] = [];
  public socialMediaForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public isLoading: boolean = true;
  private logoUrl: string;
  private iconUrl: string;
  public image: string;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService,
    private settingService: SettingsService,
    private domainService: DomainService,
  ) { }

  ngOnInit(): void {
    this.setSocialMedia(this.socialMedia);
  }

   public async getAndSetLogo(event: any) {
      const image: string = await this.commonService.convertImgToBase64(event);
      if (!image) return;
      this.c.get('logo')?.setValue(image);
      this.logoUrl = image;
    }
  
    private saveIcon(sid: number, refType: string, label: string, url: string) {
      let image: Image = {
        id: null,
        sid: sid,
        type: refType,
        label: label,
        image: url,
      };
      image.image = url
      this.domainService.createImage(image).subscribe({
        next: (response: string) => {
        },
        error: (error: HttpErrorResponse) => {
        }
      });
    }

    private getLogoImage() {
      this.domainService.getImage('SOCIAL', 'SOCIAL', this.socialMedia.id, 'logo').subscribe(image => {
        this.image=image.payload;
      });
    }

    private getIconImage() {
      this.domainService.getImage('SOCIAL', 'SOCIAL', this.socialMedia.id, 'logo').subscribe(image => {
        this.image=image.payload;
      });
    }
  
  public setSocialMedia(socialMedia?: SocialMedia) {
    if (!socialMedia)
      socialMedia = {
        id: null,
        name: null,
        logo: null,
        website:null,
        colour: null,
        icon: null,
        disabled: false,
      } as SocialMedia;
    this.socialMediaForm = this.fb.group({
      id: this.fb.control(socialMedia?.id || null),
      name: this.fb.control(socialMedia.name, [Validators.required,Validators.pattern(RegExp.name)]),
      logo: this.fb.control(socialMedia.logo, []),
      website: this.fb.control(socialMedia.website, [Validators.required,Validators.pattern(RegExp.website)]),
      colour: this.fb.control(socialMedia.colour, []),
      icon: this.fb.control(socialMedia.icon, []),
      disabled: this.fb.control(socialMedia.disabled, []),
    });
    this.socialMediaForm.valueChanges.subscribe(value => this.modified = true);
  }

  get c() {
    return this.socialMediaForm as FormGroup;
  }

  public saveSocialMedia(inProgress?: any) {
    this.submitted = true;
    if (this.socialMediaForm.valid) {
      const socialMedia: SocialMedia = this.socialMediaForm.value;
      socialMedia.logo = '';
      if (this.socialMedias.some(t => t.name.toLowerCase() === socialMedia.name.toLowerCase())) {
        this.commonService.setToastr(400, `Cannot ${socialMedia?.id?'update':'add'} the record. ${socialMedia.name} already exists.`);
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `SocialMedia ${socialMedia.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (socialMedia.id) {
        this.settingService.updateSocialMedia(socialMedia.id, socialMedia).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              if(this.logoUrl){
                // this.saveLogo(response.payload, 'SOCIAL', 'logo', this.logoUrl);
              }
             if(this.iconUrl){
              this.saveIcon(response.payload, 'SOCIAL', 'icon', this.iconUrl);
             }
           
              this.activeModal.close(true);
              this.commonService.setToastr(200, `SocialMedia ${socialMedia.name} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot update the record. SocialMedia '${socialMedia.name}' already exists.`);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.settingService.createSocialMedia(socialMedia).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
             if(this.iconUrl){
              this.saveIcon(response.payload, 'SOCIAL', 'icon', this.iconUrl);
             }
              this.activeModal.close(true);
              this.commonService.setToastr(200, `SocialMedia ${socialMedia.name} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, `Cannot add the record. SocialMedia '${socialMedia.name}' already exists.`);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
